import React from "react";
import { useField } from "formik";
import { Form, Label, Input } from "semantic-ui-react";

interface Props {
  name: string;
  placeholder?: any;
  labeltext?: any;
  type?: any;
  icon?: any;
  disabled: boolean;
}

export default function CustomTextInput(props: Props) {
  const [field, meta] = useField(props.name);
  return (
    <>
      <Form.Field error={meta.touched && !!meta.error}>
        <label>{props.labeltext}</label>
        <Input {...field} {...props} />
        {meta.touched && meta.error ? (
          <Label basic color="red">
            {meta.error}
          </Label>
        ) : null}
      </Form.Field>
    </>
  );
}
